// src/utils/timestamps.js
/**
 * Generate timestamps for Firestore documents
 * @param {Object|null} editingItem - The item being edited (null for new items)
 * @param {string} userEmail - Email of the current user
 * @returns {Object} Timestamps object
 */
export const getTimestamps = (editingItem, userEmail = 'system') => {
    const now = new Date().toISOString();
    return {
        updatedAt: now,
        updatedBy: userEmail,
        ...(!editingItem && { createdAt: now, createdBy: userEmail })
    };
};